import { Breakpoints } from '../../../index.js';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      getChildrenCount: this.getChildrenCount,
      getCurrentBp: 'mobile',
      getLayout: '',
      scrW: 0,
      bps: [],
      bpsvalues: [],
    };
  },

  computed: {
    visible() {
      return this.show;
    },
  },

  methods: {
    getScreenWidth() {
      this.scrW = window.innerWidth;
    },

    calculateScenarios() {
      const BPL = this.bpsvalues.length;

      for (let i = BPL; i > 0; i -= 1) {
        if (this.scrW >= this.bpsvalues[i - 1]) {
          this.getCurrentBp = this.bps[i - 1];
          break;
        }
      }

      // safe to calculate layout now
      this.calculateLayout();
    },

    calculateChildrenCount() {
      this.getChildrenCount = document.querySelectorAll('.nbc-suggestions-content > div').length || 0;
    },

    calculateLayout() {
      if (this.getCurrentBp === 'mobile' || this.getCurrentBp === 'sm') {
        this.getLayout = 'vertical';
      } else if (this.getCurrentBp === 'md') {
        this.getLayout = 'horizontal';
      } else if ((this.getCurrentBp === 'lg' || this.getCurrentBp === 'xl') && this.getChildrenCount >= 3) {
        this.getLayout = 'vertical';
      } else {
        this.getLayout = 'horizontal';
      }
    },

    onResize() {
      this.getScreenWidth();
      this.calculateScenarios();
    },
  },

  mounted() {
    this.bps = Breakpoints['ui-screen-points'].split(',');
    this.bpsvalues = this.bps.map(bp => parseInt(Breakpoints[`ui-screen-${bp}-min`], 10));
    // add default values at the beginning
    this.bps.unshift(this.getCurrentBp);
    this.bpsvalues.unshift(0);

    // get children count
    this.calculateChildrenCount();

    // cache screen width & scenarios
    this.onResize();

    // update on resize
    window.addEventListener('resize', this.onResize);
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },

  updated() {
    this.calculateChildrenCount();
    this.calculateScenarios();
  },
};
